import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import secureLocalStorage from "react-secure-storage";
import LoginButton from "../../registration/components/LoginButton";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import LogoutIcon from "@mui/icons-material/Logout";
import Avatar from "@mui/material/Avatar";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import { useState } from "react";
import { useRef } from "react";
import { msalInstance } from "../../../App";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  AccountCircleOutlined,
  KeyboardArrowDownOutlined,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import NavBarGrid from "./NavBarGrid";
import ActionButton from "../input-fields/ActionButton";

const AppBarMain = ({ children, isUserLoggedIn, isLeftNavBar }) => {
  //#region variables
  const drawerWidth = 240;
  const navItems = [`FAQ's`, "Contact"];
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const manageIconRef = useRef(null);
  const navigate = useNavigate();

  //#region click events
  const handleMobileView = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const handleMenuToggle = () => {
    setShowMenu(!showMenu);
  };

  const handleManageAccounts = () => {
    setShowMenu(false);
  };

  const onSignUpClick = () => {
    navigate("/create-an-account");
  };

  const handleSidebarToggle = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const onLogoutClick = () => {
    setShowPopup(true);
    setShowMenu(false);
  };
  const handleConfirmRemove = async () => {
    secureLocalStorage.setItem("fullName", "");
    secureLocalStorage.clear();
    localStorage.setItem("logout-event", Date.now().toString());

    // Make sure MSAL is initialized
    if (!msalInstance || !msalInstance.getAllAccounts) {
      console.error("MSAL instance is not properly initialized.");
      return;
    }

    try {
      await msalInstance.initialize(); // ⚠️ Only if you're using MSAL v3 or explicitly need init()
    } catch (e) {
      console.error("Failed to initialize MSAL instance", e);
      return;
    }

    msalInstance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });

    setShowPopup(false);
  };

  const handleCancelRemove = () => {
    // Close the popup without removing the item
    setShowPopup(false);
    // setShowMenu(!showMenu);
    setShowMenu(false);
  };

  //#region render components
  const MobileDrawer = (
    <Box onClick={handleMobileView} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ my: 2 }} className="alt360-logo-conatiner">
        <img src="/icons/LucraLogo.png" alt="" />
        {/* <b className='lucra-font-style'>LUCRA</b> */}
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton sx={{ textAlign: "center" }}>
              <ListItemText primary={item} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  //#region useeffect
  React.useEffect(() => {
    const handleBodyClick = (event) => {
      if (
        manageIconRef.current &&
        manageIconRef.current.contains(event.target)
      ) {
      } else {
        setShowMenu(false);
      }
    };

    document.body.addEventListener("click", handleBodyClick);

    return () => {
      document.body.removeEventListener("click", handleBodyClick);
    };
  }, []);

  //#region return
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        component="nav"
        sx={(theme) => ({
          backgroundColor: "#fff",
          color: "#000",
          boxShadow: "0 6px 16px -2px rgba(0,0,0,0.18)",
          /* borderBottom: "1px solid black", */
          zIndex: theme.zIndex.drawer + 1,
        })}
      >
        <Toolbar className="space-between">
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleMobileView}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Box
            className="alt360-logo-conatiner child-row-margin-10 align-items-center"
            sx={{ display: { xs: "none", sm: "flex", alignItems: "center" } }}
          >
            {isSidebarOpen ? (
              <img
                src="/icons/LucraLogo.png"
                alt="Lucra Logo"
                style={{ height: 45 }}
              />
            ) : (
              <img
                src="/icons/lucra-icon.png"
                alt="lucra logo"
                style={{ height: 30 }}
              />
            )}
           {
            isUserLoggedIn && 
             <IconButton onClick={handleSidebarToggle} sx={{ ml: 1, p: 0 }}>
                <img
                  src={
                    isSidebarOpen
                      ? "/icons/sidebar-close.svg"
                      : "/icons/sidebar-open.svg"
                  }
                  alt={isSidebarOpen ? "Close Sidebar" : "Open Sidebar"}
                  style={{ width: 34, height: 34 }}
                />
              </IconButton>
           }
          </Box>
          <Box className="" sx={{ display: { xs: "none", sm: "flex" } }}>
            {isUserLoggedIn === true ? (
              <>
                <div className="user-account" ref={manageIconRef}>
                  <IconButton
                    sx={{ mr: 1, p: 0 }}
                    aria-label="notifications"
                    onClick={(e) => e.stopPropagation()} // stops dropdown toggle
                  >
                    <NotificationsOutlinedIcon
                      sx={{ color: "gray", fontSize: 28 }}
                    />
                  </IconButton>
                  <span
                    onClick={handleMenuToggle}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <Avatar
                      src={secureLocalStorage.getItem("userPic") || ""}
                      sx={{
                        bgcolor: "#1F61C5",
                        width: 38,
                        height: 38,
                        fontSize: "16px",
                        fontWeight: 500,
                        mr: 1,
                      }}
                    >
                      {!secureLocalStorage.getItem("userPic") &&
                        (secureLocalStorage.getItem("fullName")
                          ? secureLocalStorage
                              .getItem("fullName")
                              .charAt(0)
                              .toUpperCase()
                          : "U")}
                    </Avatar>
                    <KeyboardArrowDownOutlined
                      className="down-arrow"
                      sx={{ color: "gray" }}
                    />
                  </span>
                </div>
              </>
            ) : (
              <div className="child-row-margin-10">
                {/* <div>
                    <ActionButton
                      variant={FieldVariants.OUTLINED} 
                      label="SIGN UP"
                      onClick={onSignUpClick} />
                  </div> */}
                <div>
                  <LoginButton msalInstance={msalInstance} />
                </div>
              </div>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleMobileView}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {MobileDrawer}
        </Drawer>
      </nav>
      <Box component="main" sx={{ width: "100%" }}>
        <Toolbar />
        {isLeftNavBar ? (
          <NavBarGrid isSidebarOpen={isSidebarOpen}>{children}</NavBarGrid>
        ) : (
          <div>{children}</div>
        )}
      </Box>
      {showMenu && (
        <div
          className="user-accountbox"
          style={{ padding: "16px", minWidth: "240px" }}
        >
          {/* User Info */}
          <Box display="flex" alignItems="start" mb={1}>
            {/* Avatar */}
            <Avatar
              sx={{ bgcolor: "#1F61C5", mr: 2, mt: 0.5, width: 40, height: 40 }}
            >
              {secureLocalStorage.getItem("fullName")?.charAt(0) || "U"}
            </Avatar>

            {/* Name, Email, Company */}
            <Box>
              <Typography
                component="div"
                sx={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#0A1A27",
                  mb: 0,
                  pb: 0,
                }}
              >
                {secureLocalStorage.getItem("fullName")}
              </Typography>
              <Typography
                component="div"
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "#0A1A27",
                  opacity: "0.6",
                  mt: 0,
                  mb: 1,
                  pt: 0,
                }}
              >
                {secureLocalStorage.getItem("userEmail")}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#1F61C5", fontWeight: 600, fontSize: "16px" }}
              >
                Goldman Sachs Co
              </Typography>
            </Box>
          </Box>

          {/* <Divider /> */}

          {/* Menu Options */}
          <Box mt={1}>
            <Box
              display="flex"
              alignItems="center"
              className="cursor-pointer"
              sx={{ px: 2, "&:hover": { bgcolor: "#f5f5f5" } }}
            >
              <SettingsOutlinedIcon
                sx={{ color: "gray", width: 22, height: 22, mr: 2 }}
              />
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#0A1A27",
                  mt: 0,
                  mb: 1,
                  pt: 0,
                }}
              >
                Settings
              </Typography>
            </Box>

            <Box
              display="flex"
              alignItems="center"
              className="cursor-pointer"
              sx={{ px: 2, "&:hover": { bgcolor: "#f5f5f5" } }}
              onClick={onLogoutClick}
            >
              <ExitToAppIcon
                sx={{ color: "gray", mr: 2, width: 22, height: 22 }}
              />
              <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                Logout
              </Typography>
            </Box>
          </Box>
        </div>
      )}

      {showPopup ? (
        <Dialog open={showPopup}>
          <DialogTitle>Confirmation</DialogTitle>
          <DialogContent>Are you sure you want to logout?</DialogContent>
          <DialogActions>
            <div className="child-row-margin-10">
              <ActionButton
                variant="outlined"
                label="Cancel"
                onClick={handleCancelRemove}
                icon={<CancelIcon />}
              />
              <ActionButton
                variant="contained"
                label="Logout"
                onClick={handleConfirmRemove}
                icon={<LogoutIcon />}
              />
            </div>
          </DialogActions>
        </Dialog>
      ) : null}
    </Box>
  );
};

export default AppBarMain;
